module.exports = __webpack_public_path__ + "static/media/1023547.6c15f29f.png";